export default __webpack_public_path__ + "static/media/Dbramante.9e46392d.svg";